import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';

import { IconCard } from '../../../../components';

import './style.scss';

const NavigationMainMenuSubComponent = ({ item }) => {
  return (
    <div className="NavigationMainMenuDesktop--subMenu">
      <Container className="NavigationMainMenuDesktop--subMenu__container">
        <div className="row">
          <div className="col-12">
            <ul className="NavigationMainMenuDesktop--subMenu__items">
              {
                item && item.get('subtree').map((subItem, i) => {
                  const subItemHref = subItem.getIn(['link', 'url']);
                  const subItemTitle = subItem.getIn(['link', 'title'], '');

                  return (
                    <li key={`menu--main--sub-menu-item-${subItemTitle}:${subItemHref}`}>
                      <div className="NavigationMainMenuDesktop--subMenu__item">
                        <IconCard
                          title={subItemTitle}
                          href={subItemHref}
                          small
                        />
                      </div>
                    </li>
                  );
                })
              }
            </ul>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NavigationMainMenuSubComponent;
